import './polyfills';
import {config} from './config';

const main = () => {
	config();
};

export {main};
